import isSameDay from 'date-fns/isSameDay';
import startOfDay from 'date-fns/startOfDay';
import startOfMonth from 'date-fns/startOfMonth';
import startOfQuarter from 'date-fns/startOfQuarter';
import startOfWeek from 'date-fns/startOfWeek';
import subDays from 'date-fns/subDays';
import { DATE_RANGE_VALIDATION_ERROR_MESSAGES } from '../../../../constants';
export const areSameRanges = (firstRange, secondRange) => {
    if (!secondRange)
        return false;
    const fallbackTimestamp = 0;
    return (isSameDay(firstRange[0] || fallbackTimestamp, secondRange[0] || fallbackTimestamp) &&
        isSameDay(firstRange[1] || fallbackTimestamp, secondRange[1] || fallbackTimestamp));
};
export const convertErrorToAcceptedForm = (error) => error === null ? undefined : DATE_RANGE_VALIDATION_ERROR_MESSAGES[error];
export const mapRangeVariantToDateRange = (rangeVariant) => {
    switch (rangeVariant) {
        case 'yesterday': {
            const yesterday = subDays(startOfDay(new Date()), 1);
            return [yesterday, yesterday];
        }
        case 'last_7_days': {
            const today = startOfDay(new Date());
            const sevenDaysAgo = subDays(today, 7);
            return [sevenDaysAgo, today];
        }
        case 'last_14_days': {
            const today = startOfDay(new Date());
            const fourteenDaysAgo = subDays(today, 14);
            return [fourteenDaysAgo, today];
        }
        case 'last_30_days': {
            const today = startOfDay(new Date());
            const thirtyDaysAgo = subDays(today, 30);
            return [thirtyDaysAgo, today];
        }
        case 'this_week': {
            const today = startOfDay(new Date());
            const firstDayOfWeek = startOfWeek(today);
            return [firstDayOfWeek, today];
        }
        case 'last_week': {
            const today = startOfDay(new Date());
            const firstDayOfWeek = startOfWeek(today);
            const lastDayOfPreviousWeek = subDays(firstDayOfWeek, 1);
            const firstDayOfPreviousWeek = startOfWeek(lastDayOfPreviousWeek);
            return [firstDayOfPreviousWeek, lastDayOfPreviousWeek];
        }
        case 'this_month': {
            const today = startOfDay(new Date());
            const firstDayOfMonth = startOfMonth(today);
            return [firstDayOfMonth, today];
        }
        case 'last_month': {
            const today = startOfDay(new Date());
            const firstDayOfMonth = startOfMonth(today);
            const lastDayOfPreviousMonth = subDays(firstDayOfMonth, 1);
            const firstDayOfPreviousMonth = startOfMonth(lastDayOfPreviousMonth);
            return [firstDayOfPreviousMonth, lastDayOfPreviousMonth];
        }
        case 'this_quarter': {
            const today = startOfDay(new Date());
            const firstDayOfQuarter = startOfQuarter(today);
            return [firstDayOfQuarter, today];
        }
        case 'last_quarter': {
            const today = startOfDay(new Date());
            const firstDayOfQuarter = startOfQuarter(today);
            const lastDayOfPreviousQuarter = subDays(firstDayOfQuarter, 1);
            const firstDayOfPreviousQuarter = startOfQuarter(lastDayOfPreviousQuarter);
            return [firstDayOfPreviousQuarter, lastDayOfPreviousQuarter];
        }
        case 'today':
        case 'custom':
        default: {
            const today = startOfDay(new Date());
            return [today, today];
        }
    }
};
export const getInitDateRange = (rangeValue, ranges) => {
    if (rangeValue.type === 'custom') {
        return rangeValue.dateRange;
    }
    if (ranges) {
        const rangeConfig = ranges.find((range) => range.type === rangeValue.type);
        if (rangeConfig) {
            return rangeConfig.getValue();
        }
    }
    return [new Date(), new Date()];
};
export const isCustom = (rangeVariant) => {
    return rangeVariant === 'custom';
};
//# sourceMappingURL=ComplexStaticDateRangePicker.service.js.map